<template>
    <div class="row">
        <div class="col-lg-12">
            <b-card class="bg-info-card">
                <profile-header></profile-header>
                
                 <div class="profile_details">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="nav-tabs-custom">
                                <b-tabs v-model="currentTab">
                                    <b-tab :title="$t('userprofile.titles.about')" active class="removeFocus">
                                        <profile-about></profile-about>
                                    </b-tab>

                                    <b-tab :title="$t('userprofile.titles.change_password')" class="removeFocus">
                                        <profile-change-password></profile-change-password>
                                    </b-tab>

                                    <b-tab :title="$t('userprofile.titles.change_profile')" class="removeFocus">
                                        <profile-change></profile-change>
                                    </b-tab>

                                    <b-tab :title="$t('userprofile.titles.company')" v-if="this.$store.state.userSelectedRole.company_id" class="removeFocus">
                                        <profile-company></profile-company>
                                    </b-tab>

                                    <b-tab :title="$t('userprofile.titles.company_certificates')" v-if="is_company_admin" class="removeFocus">
                                        <profile-company-certificates></profile-company-certificates>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import ProfileHeader from '@/components/pages/users/profile/profile_header.vue';
import ProfileAbout from '@/components/pages/users/profile/profile_about.vue';
import ProfileChangePassword from '@/components/pages/users/profile/profile_change_password.vue';
import ProfileChange from '@/components/pages/users/profile/profile_change.vue';
import ProfileCompany from '@/components/pages/users/profile/profile_company.vue';
import ProfileCompanyCertificates from '@/components/pages/users/profile/profile_company_certificates.vue';

export default {
    name: 'profile',
    components: {
        ProfileHeader,
        ProfileAbout,
        ProfileChangePassword,
        ProfileChange,
        ProfileCompany,
        ProfileCompanyCertificates
    },
    data() {
        return {
            currentTab: 0
        }
    },
    computed: {
        is_company_admin: {
            get: function () {
                if (typeof this.$store.state.userSelectedRole != 'undefined') {
                    if (typeof this.$store.state.userSelectedRole.permissions != 'undefined' && this.$store.state.userSelectedRole.company_id) {
                        for (var key in this.$store.state.userSelectedRole.permissions) {
                            if (key == 'company' && this.$store.state.userSelectedRole.permissions[key].update == 1) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            }
        }
    },
    watch: {
        is_company_admin: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    }
}
</script>

<style src="@/assets/css/user_profile.css" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/users/profile/profile.vue